module.exports = __webpack_public_path__ + "img/health_quote.a81ea56d.png";